import { Link } from "react-router-dom";

const roleLinks = [
  { label: "Software Engineer", path: "/software-engineer-interview-prep" },
  { label: "Data Scientist", path: "/data-scientist-interview-prep" },
  { label: "Product Manager", path: "/product-manager-interview-prep" },
  { label: "Consultant", path: "/consultant-interview-prep" },
  { label: "Financial Analyst", path: "/financial-analyst-interview-prep" },
  { label: "Marketing Manager", path: "/marketing-manager-interview-prep" },
];

const interviewTypeLinks = [
  { label: "Coding Interview", path: "/coding-interview-practice" },
  { label: "Case Interview", path: "/case-interview-preparation" },
  { label: "Technical Interview", path: "/technical-interview-simulator" },
  { label: "Behavioral Interview", path: "/behavioral-interview-coach" },
  { label: "System Design", path: "/system-design-interview-prep" },
];

const compareLinks = [
  { label: "OnSite vs LeetCode", path: "/vs/leetcode" },
  { label: "OnSite vs Pramp", path: "/vs/pramp" },
  { label: "OnSite vs Interviewing.io", path: "/vs/interviewing-io" },
  { label: "All Alternatives", path: "/alternatives/interview-prep-platforms" },
];

const legalLinks = [
  { label: "Privacy Policy", path: "/legal/privacy-policy" },
  { label: "Terms of Service", path: "/legal/terms-of-service" },
  { label: "Acceptable Use", path: "/legal/acceptable-use-policy" },
  { label: "AI Disclaimer", path: "/legal/ai-disclaimer" },
];

export default function PublicFooter() {
  return (
    <footer className="px-6 py-16 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        {/* Link columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Prep by Role</h4>
            <ul className="space-y-2.5">
              {roleLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">By Interview Type</h4>
            <ul className="space-y-2.5">
              {interviewTypeLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Compare</h4>
            <ul className="space-y-2.5">
              {compareLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Legal</h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <span className="text-lg font-semibold text-gray-900">OnSite</span>
            <span className="text-xs text-gray-500">by Veltus</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="mailto:hello@veltus.io" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
              Contact
            </a>
            <span className="text-sm text-gray-500">
              &copy; {new Date().getFullYear()} Veltus. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
